import * as React from "react";
import { iconList } from "../../../../../common/constants";
import { PiDogFill } from "react-icons/pi";
import { BsFillEmojiSmileFill } from "react-icons/bs";
export interface IIconPopupProps {
  show: boolean;
  onShow: React.Dispatch<React.SetStateAction<boolean>>;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  inputMessage: string;
}

const IconPopup = React.forwardRef(
  (
    { show, onShow, setInputValue, inputMessage }: IIconPopupProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => {
    const [listIcon, setListIcon] = React.useState<string[]>(
      iconList[0].children
    );
    const [idType, setId] = React.useState<string>("smile");
    const handleChooseTypeIcon = (type: string) => {
      let icon = iconList.find((i) => i.id === type);
      if (icon !== undefined) {
        setListIcon(icon?.children);
        setId(type);
      }
    };
    const handleSelectedIcon = (icon: string) => {
      setInputValue(inputMessage + icon);
    };

    return (
      <div
        ref={ref}
        style={{ display: show ? "" : "none" }}
        className="absolute   bottom-[30px] right-3 z-[100] w-80 shadow-md bg-[#373535] rounded-md rounded-br-none"
      >
        <i
          onClick={() => onShow(false)}
          className="bi hover:text-primary text-white text-base  cursor-pointer absolute top-0 right-3 bi-x"
        ></i>
        <div className="h-60 px-3 mt-2 pt-4 pb-3 has-scrollbar">
          <div className="grid grid-cols-7 gap-x-3">
            {listIcon.map((item: string, index: number) => {
              return (
                <div
                  onClick={() => handleSelectedIcon(item)}
                  key={index}
                  className="cursor-pointer p-1 select-none hover:bg-bordermood rounded-lg transition-all icon-react"
                >
                  <div>{item}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="px-3 flex gap-x-2 py-2 border-t border-bordermood">
          <div
            onClick={() => handleChooseTypeIcon("smile")}
            className="p-2 cursor-pointer rounded-full hover:bg-moodbg transition-all"
          >
            <BsFillEmojiSmileFill
              className={`text-sm ${
                idType === "smile" ? "text-primary" : "text-white"
              }`}
            ></BsFillEmojiSmileFill>
          </div>
          <div
            onClick={() => handleChooseTypeIcon("animal")}
            className="p-2 cursor-pointer rounded-full hover:bg-moodbg transition-all"
          >
            <PiDogFill
              className={`text-sm  ${
                idType === "animal" ? "text-primary" : "text-white"
              }`}
            ></PiDogFill>
          </div>
        </div>
      </div>
    );
  }
);

export default IconPopup;
